module.exports = __webpack_public_path__ + "img/emoji-loveeyes-80x80.611afcd7.png";